import { render, staticRenderFns } from "./DefectStat.vue?vue&type=template&id=5096a3f4&"
import script from "./DefectStat.vue?vue&type=script&lang=js&"
export * from "./DefectStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports